import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/preferences/entityTypes')({
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('Entity', 'ADMIN')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
})
